"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsealWithUnsealingKey = exports.unsealWithSymmetricKey = exports.sealWithSymmetricKey = exports.getUnsealingKey = exports.getSymmetricKey = exports.getSigningKey = exports.getSignatureVerificationKey = exports.getSecret = exports.getSealingKey = exports.getPassword = exports.generateSignature = void 0;
const api_factory_1 = require("./api-factory");
const post_message_api_factory_1 = require("./post-message-api-factory");
const callPostMessageApi = (0, post_message_api_factory_1.postMessageApiCallFactory)();
/**
  * Sign a message using a public/private signing key pair derived
  * the user's DiceKey using the JSON-encoded [[SigningKeyRecipe]].
 *
*/
exports.generateSignature = (0, api_factory_1.apiCallFactory)("generateSignature", callPostMessageApi);
/**
 * Derive a password from the user's DiceKey and the JSON encoded
 * [[PasswordRecipe]].
 */
exports.getPassword = (0, api_factory_1.apiCallFactory)("getPassword", callPostMessageApi);
/**
 * Derive a SealingKey from the user's DiceKey and the JSON encoded
 * [[UnsealingKeyRecipe]].
 */
exports.getSealingKey = (0, api_factory_1.apiCallFactory)("getSealingKey", callPostMessageApi);
/**
 * Derive a binary Secret from the user's DiceKey and the JSON encoded
 * [[SecretRecipe]].
 */
exports.getSecret = (0, api_factory_1.apiCallFactory)("getSecret", callPostMessageApi);
/**
 * Derive a SignatureVerificationKey from the user's DiceKey and the JSON encoded
 * [[SigningKeyRecipe]].
 */
exports.getSignatureVerificationKey = (0, api_factory_1.apiCallFactory)("getSignatureVerificationKey", callPostMessageApi);
/**
 * Derive a SigningKey from the user's DiceKey and the JSON encoded
 * [[SigningKeyRecipe]].
 */
exports.getSigningKey = (0, api_factory_1.apiCallFactory)("getSigningKey", callPostMessageApi);
/**
 * Derive a SymmetricKey from the user's DiceKey and the JSON encoded
 * [[SymmetricKeyRecipe]].
 */
exports.getSymmetricKey = (0, api_factory_1.apiCallFactory)("getSymmetricKey", callPostMessageApi);
/**
 * Derive an UnsealingKey from the user's DiceKey and the JSON encoded
 * [[UnsealingKeyRecipe]].
 */
exports.getUnsealingKey = (0, api_factory_1.apiCallFactory)("getUnsealingKey", callPostMessageApi);
/**
 * Seal a message with a SymmetricKey derived from from the user's DiceKey and the JSON encoded
 * [[SymmetricKeyRecipe]].
 */
exports.sealWithSymmetricKey = (0, api_factory_1.apiCallFactory)("sealWithSymmetricKey", callPostMessageApi);
/**
 * Unseal a message sealed with a SymmetricKey derived from from the user's DiceKey and the JSON encoded
 * [[SymmetricKeyRecipe]].
 */
exports.unsealWithSymmetricKey = (0, api_factory_1.apiCallFactory)("unsealWithSymmetricKey", callPostMessageApi);
/**
 * Unseal a message sealed with an UnsealingKey derived from from the user's DiceKey and the JSON encoded
 * [[UnsealingKeyRecipe]].
 */
exports.unsealWithUnsealingKey = (0, api_factory_1.apiCallFactory)("unsealWithUnsealingKey", callPostMessageApi);
//# sourceMappingURL=post-message-api.js.map